import React, {useEffect} from "react";
import BackArrow from "../../../../../../assets/svg/backArrow.svg";
import {TemplateImgs} from "./tableTemplateImgs";

const TableTempletes = (props: any) => {

    return (
        <div style={{width: "100%", height: "calc(100vh - 125px)"}}>
            <div onClick={() => props.setShowTableTemplates(false)} style={{margin: "10px 3px", display: "flex", cursor: "pointer"}}>
                <img src={BackArrow} height="25px" width="10px" alt="back" />
                <div style={{marginLeft: "8px", fontWeight: 700, fontSize: "17px", color: "#282B31"}}>Templates</div>
            </div>
            <div>
                {TemplateImgs()}
            </div>
        </div>
    )
}

export default TableTempletes;